module.exports = __webpack_public_path__ + "img/n16.a22929c3.png";